import { jsx as _jsx } from "react/jsx-runtime";
import { showNotification } from '../../../../../../../app/common/helpers/notifications';
import { useApiMutation } from '../../../../../../infra/api';
import { useBreakpoints } from '../../../../../../infra/dls/hooks/use-get-breakpoints';
import { endpoints } from '../../../../network';
import { DemoSendCampaignModal } from './demo-send-campaign-modal';
import { useDemoCampaignForm } from './use-demo-send-campaign-form';
import { useRouteParams } from '../../../../../../infra/routing';
import { useEditableField } from '../../../hooks/use-editable-field';
export var DemoSendCampaignModalContainer = function (_a) {
    var _b, _c;
    var onClose = _a.onClose;
    var isMobileOrSmaller = useBreakpoints().isMobileOrSmaller;
    var sendSmsField = useEditableField('sendSms').field;
    var campaignId = useRouteParams().campaignId;
    var _d = useDemoCampaignForm(), control = _d.control, handleSubmit = _d.handleSubmit, errors = _d.formState.errors;
    var _e = useApiMutation({
        endpoint: endpoints.sendPreviewMutation,
        options: {
            onSuccess: function () {
                showNotification({
                    title: 'Test Campaign Sent Successfully!',
                    message: 
                    // eslint-disable-next-line max-len
                    'Your test campaign is on its way. Give it a review to make sure everything looks just right before sending it to your audience',
                    autoDismiss: 8,
                });
                onClose(true);
            },
            onError: function () {
                showNotification({
                    title: 'Test Campaign Failed to Send',
                    message: 
                    // eslint-disable-next-line max-len
                    'Something went wrong while sending your test campaign. Try again shortly, and if the issue keeps happening, reach out to our support team.',
                    autoDismiss: 8,
                });
            },
        },
    }), sendPreviewCampaign = _e.mutate, isLoading = _e.isLoading;
    var handleFormSubmit = handleSubmit(function (data) {
        sendPreviewCampaign({
            campaignId: campaignId,
            // should be explicitly undefined
            phone: data.phone || undefined,
            email: data.email || undefined,
        });
    });
    return (_jsx(DemoSendCampaignModal, { isLoading: isLoading, isMobileOrSmaller: isMobileOrSmaller, onClose: onClose, onSubmit: handleFormSubmit, control: control, emailErrorMessage: (_b = errors.email) === null || _b === void 0 ? void 0 : _b.message, phoneErrorMessage: (_c = errors.phone) === null || _c === void 0 ? void 0 : _c.message, shouldShowPhoneInput: sendSmsField.value }));
};
